@if (isMatMenu) {
  <button mat-menu-item
          data-test="dms-openEditFolderModal-button"
          [matTooltip]="title"
          [matTooltipDisabled]="isMatMenu"
          [ngClass]="btnClass"
          [disabled]="disabled"
          (click)="openEditFolderModal()">
    <i [hidden]="isAdd || labelOnly" class="icon fas fa-fw fa-pencil-alt"></i>
    <i [hidden]="!isAdd" class="fas fa-lg fa-folder-plus" [ngClass]="{ 'fa-fw icon' : isMatMenu }"></i>
    <span [hidden]="iconOnly" [class.ml-1]="!isAdd && !isMatMenu">
      {{ title }}
    </span>
  </button>
} @else {
  <sk-button [appearance]="iconOnly ? 'icon' : 'text'"
             data-test="dms-openEditFolderModal-button"
             [color]="iconOnly ? 'unspecified' : 'primary'"
             [label]="!iconOnly ? title : ''"
             [ngClass]="btnClass"
             [matTooltip]="title"
             [matTooltipDisabled]="isMatMenu"
             (click)="openEditFolderModal()">
    @if (iconOnly) {
      <i [hidden]="isAdd || labelOnly" class="icon fas fa-fw fa-pencil-alt"></i>
      <i [hidden]="!isAdd" class="fas fa-lg fa-folder-plus" [ngClass]="{ 'fa-fw icon' : isMatMenu }"></i>
    } @else {
      <ng-template buttonPrefix>
        <i [hidden]="isAdd || labelOnly" class="icon fas fa-fw fa-pencil-alt"></i>
        <i [hidden]="!isAdd" class="fas fa-lg fa-folder-plus" [ngClass]="{ 'fa-fw icon' : isMatMenu }"></i>
      </ng-template>
    }
  </sk-button>
}
